const initialState = {
  dataDetailAmibo: {},
}

function reducer (state = initialState, action) {
  switch (action.type) {
    case 'DATADETAILAMIBO/CHANGEDETAILAMIBO':
      return {...state, dataDetailAmibo: action.payload}
    default:
      return state
  }
}

export default reducer